module.exports = __webpack_public_path__ + "img/cegep_beauce_appalache.4292ab94.webp";